module.exports = __webpack_public_path__ + "static/media/children1.d2f9c840.png";